import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { SiteEditor } from "@/components/sites/editor/site-editor";

// Configuración → Sitios → un sitio: editor visual (vista previa en vivo y
// panel de páginas y bloques). Edita el sitio en el borrador del esquema.
// Vive junto a `sites/index.tsx` (no bajo `sites.tsx`) para que la lista no
// sea la ruta padre del editor.
export const Route = createFileRoute("/_authenticated/settings/_layout/sites/$siteKey")({
  component: SiteEditorRoute,
});

function SiteEditorRoute() {
  const { siteKey } = Route.useParams();
  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["read"] }]}>
      <SiteEditor siteKey={siteKey} />
    </RouteGuardPermissions>
  );
}
